// Admin Dashboard Page translations
export const adminDashboardTranslations = {
    en: {
        // Page header
        dashboard: "Dashboard",
        welcomeBack: "Welcome back! Here's an overview of your store performance.",
        loadingDashboardData: "Loading dashboard data...",

        // Error messages
        failedToLoadDashboardData: "Failed to load dashboard data. Please try again later.",

        // Stats
        totalSales: "Total Sales",
        totalOrders: "Total Orders",
        avgOrderValue: "Avg. Order Value",

        // Recent Orders Section
        recentOrders: "Recent Orders",
        viewAll: "View All",
        orderId: "Order ID",
        customer: "Customer",
        date: "Date",
        status: "Status",
        total: "Total",
        actions: "Actions",
        view: "View",
        noRecentOrdersFound: "No recent orders found",

        // Top Products Section
        topSellingProducts: "Top Selling Products",
        viewAllProducts: "View All Products",
        product: "Product",
        unitsSold: "Units Sold",
        revenue: "Revenue",
        edit: "Edit",
        noProductDataAvailable: "No product data available",

        // Quick Actions Section
        quickActions: "Quick Actions",
        addNewProduct: "Add New Product",
        processOrders: "Process Orders",
        updateInventory: "Update Inventory",
        storeSettings: "Store Settings",

        // Status badges
        delivered: "Delivered",
        processing: "Processing",
        pending: "Pending",
        cancelled: "Cancelled"
    },
    ar: {
        // Page header
        dashboard: "لوحة التحكم",
        welcomeBack: "أهلاً بعودتك! إليك نظرة عامة على أداء متجرك.",
        loadingDashboardData: "جارٍ تحميل بيانات لوحة التحكم...",

        // Error messages
        failedToLoadDashboardData: "فشل في تحميل بيانات لوحة التحكم. يرجى المحاولة مرة أخرى لاحقاً.",

        // Stats
        totalSales: "إجمالي المبيعات",
        totalOrders: "إجمالي الطلبات",
        avgOrderValue: "متوسط قيمة الطلب",

        // Recent Orders Section
        recentOrders: "الطلبات الحديثة",
        viewAll: "عرض الكل",
        orderId: "معرف الطلب",
        customer: "العميل",
        date: "التاريخ",
        status: "الحالة",
        total: "المجموع",
        actions: "الإجراءات",
        view: "عرض",
        noRecentOrdersFound: "لم يتم العثور على طلبات حديثة",

        // Top Products Section
        topSellingProducts: "المنتجات الأكثر مبيعاً",
        viewAllProducts: "عرض جميع المنتجات",
        product: "المنتج",
        unitsSold: "الوحدات المباعة",
        revenue: "الإيرادات",
        edit: "تعديل",
        noProductDataAvailable: "لا توجد بيانات منتجات متاحة",

        // Quick Actions Section
        quickActions: "الإجراءات السريعة",
        addNewProduct: "إضافة منتج جديد",
        processOrders: "معالجة الطلبات",
        updateInventory: "تحديث المخزون",
        storeSettings: "إعدادات المتجر",

        // Status badges
        delivered: "مُسلم",
        processing: "قيد المعالجة",
        pending: "معلق",
        cancelled: "ملغي"
    }
};

// Translation hook for admin dashboard
export const useAdminDashboardTranslation = (language = 'en') => {
    const t = (key, replacements = {}) => {
        let translation = adminDashboardTranslations[language]?.[key] || adminDashboardTranslations['en'][key] || key;

        // Handle string replacements like {message}
        Object.keys(replacements).forEach(placeholder => {
            translation = translation.replace(new RegExp(`{${placeholder}}`, 'g'), replacements[placeholder]);
        });

        return translation;
    };

    return { t };
};